import { styled } from '@core-ui/react-stitch';

const DrawerTopSection = styled.div(
  ({ theme, isBRRedesignEnabled, position }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    borderBottom: `1px solid ${theme.color.gray20}`,
    ...(isBRRedesignEnabled && {
      padding:
        position === 'drawer'
          ? '1.1875rem 0.9375rem 0.625rem 1.1875rem'
          : '1.5625rem 0.9375rem 0.625rem 1.1875rem',
    }),
  })
);

export default DrawerTopSection;
